import {createContext, useContext} from "react";
import Encounter from "@/encounter/model/Encounter.ts";

export type ActiveEncounter = Pick<Encounter, "id" | "name" | "campaignId">;

export type ActiveEncounterContextValue = {
    activeEncounter: ActiveEncounter | undefined;
    setActiveEncounter: (encounter: ActiveEncounter | undefined) => void;
};

export const ActiveEncounterContext = createContext<ActiveEncounterContextValue | null>(null);

export function useActiveEncounter(): ActiveEncounterContextValue {
    const context = useContext(ActiveEncounterContext);
    if (!context) throw new Error("useActiveEncounter must be used within an ActiveEncounterProvider");
    return context;
}
